import api from './index';
//
let exports = {};
// 查看维修费用单列表
exports.getShopRepairFeeBillList = function (data, callback) {
    api.post('/shop/repair/fee/bill/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 查看维修费用单
exports.getShopRepairFeeBillById = function (param, callback) {
    api.get('/shop/repair/fee/bill/get/by/id')
    .params(param)
    .done(callback)
    .fail(callback)
    .go();
};
// 查看维修费用单
exports.updateShopRepairFeeBillExamineDepart = function (data, callback) {
    api.post('/shop/repair/fee/bill/examine/depart/update/by/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查看维修费用单
exports.updateShopRepairFeeBillExamineDepartByIds = function (data, callback) {
    api.post('/shop/repair/fee/bill/depart/update/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 查看维修费单项
exports.getShopRepairFeeItemList = function (data, callback) {
    api.post('/shop/repair/fee/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 导出
exports.saveShopRepairFeeItemForExport = function (data, callback) {
    api.post('/shop/repair/fee/item/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopRepair.js
// module id = 277
// module chunks = 0